export default __webpack_public_path__ + "static/media/curricula.e109247f.svg";